import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RecoveryActions } from "./redux/actions/RecoveryActions";
import Input from "./components/Input";
import { validateEmail } from "./utils/helperFunctions";
import "./salasananPalautus.css";

const mapDispatchToProps = (dispatch) => ({
  sendEmailToUser: (email) => dispatch(RecoveryActions.sendEmailToUser(email)),
});

function SalasananPalautus(props) {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    document.title = "Salasanan palautus - mitattu.fi";
    // Remove previous meta description if exists
    const oldMeta = document.querySelector('meta[name="description"]');
    if (oldMeta) document.head.removeChild(oldMeta);
    // Add new meta description
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = "Sisäilmamittauksen hinnasto ja yhteydenotto";
    document.head.appendChild(meta);
  }, []);

  const onChangeEvent = (evt) => {
    setEmail(evt.target.value);
  };

  const postForm = async () => {
    if (!validateEmail(email)) {
      setError("Tarkista antamasi sähköpostiosoite");
      return;
    }
    props.sendEmailToUser(email);
    navigate("/palautetaan/");
  };

  return (
    <div className="salasana-page">
      <h1>Palauta unohtunut salasana</h1>
      <div className="restore-form">
        Ei hätää. Anna sähköpostiosoite, jolla olet kirjautunut sisään. Saat
        sähköpostiisi ohjeet salasanan palauttamiseksi.
        <Input
          label="Sähköposti"
          id="email"
          type="email"
          onChange={onChangeEvent}
        />
        <p style={{ color: "red" }}>{error}</p>
        <input
          type="submit"
          onClick={postForm}
          className="button"
          value="Lähetä"
        />
      </div>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(SalasananPalautus);